import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['spinner']

  connect() {
    document.addEventListener('turbo:submit-start', this.show.bind(this))
    document.addEventListener('turbo:before-fetch-request', this.show.bind(this))
    document.addEventListener('turbo:before-fetch-response', this.hide.bind(this))
    document.addEventListener('turbo:submit-end', this.hide.bind(this))
    document.addEventListener('turbo:load', this.hide.bind(this))
    document.addEventListener('turbo:visit', this.show.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:submit-start', this.show.bind(this))
    document.removeEventListener('turbo:before-fetch-request', this.show.bind(this))
    document.removeEventListener('turbo:before-fetch-response', this.hide.bind(this))
    document.removeEventListener('turbo:submit-end', this.hide.bind(this))
    document.removeEventListener('turbo:load', this.hide.bind(this))
    document.removeEventListener('turbo:visit', this.show.bind(this))
  }

  show(event) {
    const notPrefetch = event.detail.fetchOptions?.headers?.['X-Sec-Purpose'] !== 'prefetch'

    if (notPrefetch) {
      this.spinnerTarget.classList.remove('hidden')
    }
  }

  hide() {
    this.spinnerTarget.classList.add('hidden')
  }
}
